export const OPEN_SPREADSHEET = 'OPEN_SPREADSHEET'
export const GET_SHEET_NAMES = 'GET_SHEET_NAMES'
export const GET_COLUMN = 'GET_COLUMN'
export const GET_ROW = 'GET_ROW'
export const GET_CELL = 'GET_CELL'
export const WRITE_CELL = 'WRITE_CELL'
export const DELETE_ROW = 'DELETE_ROW'
export const DELETE_COLUMN = "DELETE_COLUMN"
export const GET_RANGE = 'GET_RANGE'
export const GET_CELL_COLOR = 'GET_CELL_COLOR'
export const SET_RANGE_COLOR = 'SET_RANGE_COLOR'
export const WRITE_RANGE = 'WRITE_RANGE'
export const GET_CELL_FORMULA = 'GET_CELL_FORMULA'
export const DELETE_RANGE = 'DELETE_RANGE'
export const APPEND_RANGE = 'APPEND_RANGE'
export const CREATE_PIVOT_TABLE = 'CREATE_PIVOT_TABLE'
export const CONVERT_XLSX = "CONVERT_XLSX"
export const FILTER_COLUMN = "FILTER_COLUMN"
export const INSERT_COLUMN = "INSERT_COLUMN"
export const HIDE_COLUMN = "HIDE_COLUMN"
export const CREATE_EXCEL = "CREATE_EXCEL"
export const REFRESH_EXCEL = "REFRESH_EXCEL"
export const CLEAR_CACHE = "CLEAR_CACHE"
export const VLOOK_UP = "VLOOK_UP"